import Backbone from "backbone";
import { View } from "./base-database-reader";
import { DB_PROVIDERS } from "./configs/db-providers";

class Db2zOS extends View {
    setup() {
        this.model.get("connectionParams").set("type", DB_PROVIDERS.DB2ZOS.id);
    }
}

export default {
    View: Db2zOS,
    vent: new Backbone.Model()
};
